
import request from '@/utils/request';
import { TableListQueryParams, InitDataType, validInfoType } from './data.d'


//sku列表
export async function getSkuPageList(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/getSkuPageList',
        method: 'POST',
        data: params,
    });
}

export async function saveSku(params:TableListQueryParams): Promise<any> {
    return request({
        url: '/seller/v1/sku/saveSku',
        method: 'POST',
        data: params,
    });
}

//获取列表
export async function getPageList(params:TableListQueryParams) {
    return request({
        url: '/seller/v1/userAddress/getUserAddressList',
        method: 'POST',
        data: params
    })
}

export async function createOrder(params:InitDataType) {
    return request({
        url: '/seller/v1/order/createOrder',
        method: 'POST',
        data: params
    })
}

// 查询日期有效的币种兑换汇率详情
export async function validInfo(params:validInfoType) {
    return request({
        url: '/seller/v1/currencyExchange/validInfo',
        method: 'POST',
        data: params
    })
}

